import { render, staticRenderFns } from "./Equipos.vue?vue&type=template&id=bec598f4&"
import script from "./Equipos.vue?vue&type=script&lang=ts&"
export * from "./Equipos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports